import axios from 'axios'
import toast from 'react-hot-toast'
import create, { GetState, SetState } from 'zustand'
import { Axios } from '../utils/axios'
import { handleAxiosError } from '../utils/error'

type ResetState = {
  email?: string
  sendOTP: (email: string) => void
  verifyOTP: (email: string) => void
  setPin: (pin: string) => void
  loading: boolean
  otp: string
  errorMessage: string
  screen?: string
  setScreen: (loading: any) => void
  login: (loading: any) => any
  userDetails: any
}

const defaultState = {
  loading: false,
  plate: null,
  token: null,
  otp: '',
  screen: '',
  errorMessage: ''
}

const ResetStore = (set: SetState<ResetState>, get: GetState<ResetState>) => ({
  ...defaultState,
  setScreen: (screen: string) => {
    set({ screen })
  },
  reset: () => {
    set(defaultState)
  },
  sendOTP: async (email: string) => {
    set({ loading: true })
    try {
      const { data } = await Axios.post('/auth/pin-reset', { email })
      set({ loading: false, email })
      toast.success(data.message)
      return true
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  verifyOTP: async (otp: string) => {
    const { email } = get()
    set({ loading: true })
    try {
      const { data } = await Axios.patch('auth/reset-pin/verify', {
        otp,
        email
      })
      toast.success(data.message)
      set({ loading: false, otp })
    } catch (error: any) {
      set({ loading: false, errorMessage: error?.response?.data?.message })
      throw new Error(error?.response?.data?.message)
    }
  },
  setPin: async (pin: string) => {
    set({ loading: true })
    const { email, otp } = get()
    try {
      const { data } = await Axios.patch('/auth/reset-pin', { pin, email, otp })
      toast.success(data.message)
      set({ loading: false, email })
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  changePin: async (values: any) => {
    set({ loading: true })
    try {
      const { data } = await Axios.patch('/user/change-pin', values)
      toast.success(data.message)
      set({ loading: false })
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  login: async (values: any) => {
    set({ loading: true })
    try {
      const { data } = await Axios.post('/auth/login', values)
      toast.success('Successfully Logged In.')
      set({ loading: false, userDetails: data.data.user })
      localStorage.setItem('token', data.data.token)
      // const notification_token = await getToken()
      // localStorage.setItem('notification_token', notification_token)
      // await axios.post(
      //   'https://kappa-insurance-middleware.test.woven.finance/v1/device',
      //   { notification_token },
      //   { headers: { Authorization: `Bearer ${data.data.token}` } }
      // )
      return data.data
    } catch (error: any) {
      set({ loading: false, errorMessage: error?.response?.data?.message })
      throw new Error(error?.response?.data?.message)
    }
  }
})

const useResetStore = create<ResetState>(ResetStore)
export default useResetStore
